import {
    HOT,
    COLD,
    isTouchMap,
    getCounties,
    getDesignCenters,
    buildDcInfo,
    buildCountyInfo,
    createMap,
    createInfoWindow,
    createCountyPolygon,
    createDcMarker,
    assignDcToCounty,
    loadGoogleMaps,
} from "../inc/wwb_map.js";

window.initWwbPageMap = () => {
    const el = document.getElementById("wwb-page-map");
    if (!el || !(window.google && window.google.maps)) return;
    const counties = getCounties();
    const dcs = getDesignCenters();
    const pin = el.getAttribute("data-dc-pin") || "";
    const map = createMap(el, {
        zoomControl: true,
        gestureHandling: "greedy",
    });
    const infowindow = createInfoWindow({ maxWidth: 320 });
    const bounds = new google.maps.LatLngBounds();
    const polygonByName = {};

    counties.forEach((county) => {
        if (!county.border || !county.border.length) return;
        const entry = createCountyPolygon(map, county, bounds);
        const polygon = entry.polygon;
        polygon.addListener("mouseover", () => {
            polygon.setOptions(HOT);
            infowindow.setContent(entry.content || buildCountyInfo(entry.county, entry.designCenters));
            infowindow.setPosition(entry.center);
            infowindow.open(map);
        });
        polygon.addListener("mouseout", () => {
            polygon.setOptions(COLD);
        });
        polygon.addListener("click", () => {
            if (isTouchMap()) {
                infowindow.setContent(entry.content || buildCountyInfo(entry.county, entry.designCenters));
                infowindow.setPosition(entry.center);
                infowindow.open(map);
            } else if (county.permalink) {
                window.location.href = county.permalink;
            }
        });
        polygonByName[county.name] = entry;
    });

    dcs.forEach((dc) => {
        if (dc.lat == null || dc.lng == null) return;
        const pos = new google.maps.LatLng(dc.lat, dc.lng);
        const icon = pin
            ? { url: pin, scaledSize: new google.maps.Size(32, 32), anchor: new google.maps.Point(16, 16) }
            : null;
        const marker = createDcMarker(map, pos, dc, icon);
        const containing = assignDcToCounty(pos, dc, polygonByName);
        marker.addListener("mouseover", () => {
            infowindow.setContent(containing ? (containing.content || buildCountyInfo(containing.county, containing.designCenters)) : buildDcInfo(dc));
            infowindow.setPosition(pos);
            infowindow.open(map);
        });
        marker.addListener("mouseout", () => {
            infowindow.close();
        });
        marker.addListener("click", () => {
            if (isTouchMap()) {
                infowindow.setContent(containing ? (containing.content || buildCountyInfo(containing.county, containing.designCenters)) : buildDcInfo(dc));
                infowindow.setPosition(pos);
                infowindow.open(map);
            } else if (dc.permalink) {
                window.location.href = dc.permalink;
            }
        });
        bounds.extend(pos);
    });

    for (const name in polygonByName) {
        const entry = polygonByName[name];
        entry.content = buildCountyInfo(entry.county, entry.designCenters);
        if (entry.designCenters.length) {
            const link = document.querySelector(`.wwb-county-link[data-county="${name.replace(/"/g, '\\"')}"]`);
            if (link && !link.querySelector(".wwb-county-dc")) {
                const star = document.createElement("span");
                star.className = "wwb-county-dc";
                star.textContent = "★ Design Center";
                link.appendChild(star);
            }
        }
    }
    if (!bounds.isEmpty()) map.fitBounds(bounds, { top: 40, right: 40, bottom: 40, left: 40 });
    window.__tilsonMapState = { map, infowindow, polygonByName };
};

const loadWwbPageMap = () => {
    const el = document.getElementById("wwb-page-map");
    if (!el) return;
    loadGoogleMaps("wwb-page-gmaps-js", "initWwbPageMap", window.initWwbPageMap);
};

const initWhereWeBuild = () => {
    const root = document.querySelector(".wwb");
    if (!root) return;

    const nav = document.getElementById("wwbRegionNav");
    if (nav) {
        nav.querySelectorAll(".wwb-region-link").forEach((btn) => {
            btn.addEventListener("click", () => {
                const wrap = btn.nextElementSibling;
                const open = btn.classList.contains("active");
                nav.querySelectorAll(".wwb-region-link").forEach((l) => l.classList.remove("active"));
                nav.querySelectorAll(".wwb-region-counties-wrap").forEach((w) => w.classList.remove("open"));
                if (!open) {
                    btn.classList.add("active");
                    if (wrap) wrap.classList.add("open");
                }
            });
        });

        const previewCounty = (name, link, on) => {
            if (link) link.classList.toggle("is-hot", on);
            const st = window.__tilsonMapState;
            if (!st) return;
            const entry = st.polygonByName[name];
            if (!entry) return;
            if (on) {
                entry.polygon.setOptions(HOT);
                st.infowindow.setContent(entry.content || buildCountyInfo(entry.county, entry.designCenters));
                st.infowindow.setPosition(entry.center);
                st.infowindow.open(st.map);
            } else {
                entry.polygon.setOptions(COLD);
                st.infowindow.close();
            }
        };
        nav.querySelectorAll(".wwb-county-link").forEach((link) => {
            const name = link.getAttribute("data-county");
            if (!name) return;
            link.addEventListener("mouseenter", () => previewCounty(name, link, true));
            link.addEventListener("mouseleave", () => previewCounty(name, link, false));
        });

        nav.querySelectorAll(".wwb-region-item").forEach((item) => {
            const btn = item.querySelector(".wwb-region-link");
            if (!btn || btn.hasAttribute("data-all-counties")) return;
            const names = Array.from(item.querySelectorAll(".wwb-county-link"))
                .map((l) => l.getAttribute("data-county"))
                .filter(Boolean);
            if (!names.length) return;
            btn.addEventListener("mouseenter", () => {
                const st = window.__tilsonMapState;
                if (!st) return;
                names.forEach((n) => { const e = st.polygonByName[n]; if (e) e.polygon.setOptions(HOT); });
            });
            btn.addEventListener("mouseleave", () => {
                const st = window.__tilsonMapState;
                if (!st) return;
                names.forEach((n) => { const e = st.polygonByName[n]; if (e) e.polygon.setOptions(COLD); });
                st.infowindow.close();
            });
        });
    }

    root.querySelectorAll(".wwb-loc-tab").forEach((tab) => {
        tab.addEventListener("click", () => {
            root.querySelectorAll(".wwb-loc-tab").forEach((t) => {
                t.classList.remove("active");
                t.setAttribute("aria-selected", "false");
            });
            root.querySelectorAll(".wwb-loc-panel").forEach((p) => p.classList.remove("active"));
            tab.classList.add("active");
            tab.setAttribute("aria-selected", "true");
            const panel = document.getElementById("wwb-panel-" + tab.dataset.panel);
            if (panel) panel.classList.add("active");
        });
    });

    const searchInput = document.getElementById("wwbCountySearch");
    const searchResults = document.getElementById("wwbSearchResults");
    if (searchInput && searchResults && nav) {
        const seen = {};
        const counties = [];
        nav.querySelectorAll(".wwb-county-link").forEach((a) => {
            const name = a.getAttribute("data-county");
            if (!name) return;
            const item = a.closest(".wwb-region-item");
            const rlabel = item ? item.querySelector(".wwb-region-link span") : null;
            const region = rlabel ? rlabel.textContent : "";
            if (!seen[name]) {
                seen[name] = { name: name, permalink: a.getAttribute("href"), region: region };
                counties.push(seen[name]);
            } else if ((!seen[name].region || seen[name].region === "All Counties A–Z") && region && region !== "All Counties A–Z") {
                seen[name].region = region;
            }
        });
        const setHot = (name, on) => {
            const st = window.__tilsonMapState;
            if (!st || !st.polygonByName[name]) return;
            st.polygonByName[name].polygon.setOptions(on ? HOT : COLD);
        };
        searchInput.addEventListener("input", () => {
            const q = searchInput.value.trim().toLowerCase();
            searchResults.innerHTML = "";
            if (q.length < 2) {
                searchResults.classList.remove("visible");
                return;
            }
            const matches = counties.filter((c) => c.name.toLowerCase().indexOf(q) > -1).slice(0, 12);
            if (!matches.length) {
                searchResults.innerHTML = `<div class="wwb-search-no-results">No counties found</div>`;
                searchResults.classList.add("visible");
                return;
            }
            matches.forEach((c) => {
                const item = document.createElement("a");
                item.href = c.permalink || "#";
                item.className = "wwb-search-result";
                item.innerHTML = `<span>${c.name}</span>${c.region && c.region !== "All Counties A–Z" ? `<span class="wwb-search-result-region">${c.region}</span>` : ""}`;
                item.addEventListener("mouseenter", () => setHot(c.name, true));
                item.addEventListener("mouseleave", () => setHot(c.name, false));
                item.addEventListener("click", (ev) => {
                    const st = window.__tilsonMapState;
                    if (st && st.polygonByName[c.name]) {
                        ev.preventDefault();
                        searchInput.value = "";
                        searchResults.classList.remove("visible");
                        const e = st.polygonByName[c.name];
                        setHot(c.name, true);
                        st.infowindow.setContent(e.content);
                        st.infowindow.setPosition(e.center);
                        st.infowindow.open(st.map);
                        st.map.panTo(e.center);
                        st.map.setZoom(9);
                    }
                });
                searchResults.appendChild(item);
            });
            searchResults.classList.add("visible");
        });
        document.addEventListener("click", (e) => {
            if (!e.target.closest(".wwb-panel-search-wrap")) searchResults.classList.remove("visible");
        });
    }

    loadWwbPageMap();
};

initWhereWeBuild();
